const initUniformFormFields = require("./initUniformFormFields");

/**
 * @return {void}
 */
module.exports = function initAllGlobalMarketoFields() {
    document.querySelectorAll('[data-component="global-marketo-fields"]').forEach(globalMarketoFieldsContainer => {
        if (globalMarketoFieldsContainer instanceof HTMLDivElement) {
            initUniformFormFields(globalMarketoFieldsContainer);
        }
    });
}